import React, { VFC } from 'react';
import { IIconProps } from './types';

const FilePlusIcon: VFC<IIconProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.35 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5.35" />
    <path d="M14 2v5a1 1 0 0 0 1 1h5" />
    <path d="M14 19h6" />
    <path d="M17 16v6" />
  </svg>
);

export default FilePlusIcon;
